import { render, staticRenderFns } from "./BankStatementUpload.vue?vue&type=template&id=71f24222&"
import script from "./BankStatementUpload.vue?vue&type=script&lang=js&"
export * from "./BankStatementUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports